<template>
  <div>
    <b-modal id="modalTelephoneService" ref="modalTelephoneService" :title="$t('Telephony service')" hide-footer size="xl" @shown="shown">
      <div v-if="editItem  && (serviceType === 6)">
          <b-tabs pills card vertical>
            <b-tab :title="$t('Main')">
              <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
                <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
                <b-form-invalid-feedback id="inputFeedbackName">
                  {{ $t('Enter title') }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="editItem.service_data.comment"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
              </b-form-group>
              <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
                <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
                <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Service parameters')">
              <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
                <b-form-invalid-feedback id="inputFeedbackCost">
                  {{ $t('Enter cost') }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Minimal invoice summ')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.min_charge"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="chargeMethodList" v-model="editItem.periodic_service_data.charge_method"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="policyList" v-model="editItem.periodic_service_data.policy_id"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="schemeList" v-model="editItem.periodic_service_data.scheme_id"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.free_time"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.first_period_length"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Starting period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.first_period_step"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Next period step')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.second_period_step"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Tariffication unit size')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.telephony_service_data.cost_info.time_unit_size"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Limit of simulaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="editItem.periodic_service_data.radius_sessions_limit"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Discount free time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox v-model="editItem.telephony_service_data.cost_info.discount_free_time"/>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Price editor')">
              <md-button class="md-raised md-dense" @click="showAddTelDirections">{{ $t('Direction') }}</md-button>
              <md-button class="md-raised md-dense" @click="showAddTelZones">{{ $t('Zone') }}</md-button>
              <md-button class="md-raised md-dense" @click="showAddTimeRange">{{ $t('Time range') }}</md-button>
              <b-card>
                <b-table striped small hover responsive :fields="fieldsFromCostTimeRange" :items="itemsFromCostTable" show-empty :emptyText="$t('There are no records to show')">
                  <template #cell()="data">
                    <span v-if="data.field.key == 'label'">
                      <i @click.stop="deleteCost(data.item)" class="danger fa fa-trash-alt fa-lg" />
                      <b>{{ data.value }}</b>
                    </span>
                    <md-field v-else class="small">
                      <md-input v-model="data.item[data.field.key]" type="number"></md-input>
                    </md-field>
                  </template>
                  <template #head()="data">
                    <span v-if="data.column != 'label'">
                      <i @click.stop="deleteTimeRange({time_range_id: Number(data.column)})" class="danger fa fa-trash-alt fa-lg" />
                      {{ data.label }}
                    </span>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Tariffication borders')">
              <md-button class="md-raised md-dense" @click="showAddTelDirBorder">{{ $t('Direction') }}</md-button>
              <md-button class="md-raised md-dense" @click="showAddTelZonesBorder">{{ $t('Zone') }}</md-button>
              <b-card>
                <b-table striped small hover responsive :fields="tarifficationBordersFields" :items="borderRoll" show-empty :emptyText="$t('There are no records to show')">
                  <template #cell()="data">
                    <span v-if="['nameTel'].includes(data.field.key)">
                      <i @click.stop="deleteBorder(data.item)" class="danger fa fa-trash-alt fa-lg" />
                      <b>{{ data.value }}</b>
                    </span>
                    <md-field v-if="!['nameTel'].includes(data.field.key)" class="small">
                      <md-input v-model="data.item[data.field.key]" type="number"></md-input>
                    </md-field>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Prepaid values')">
              <md-button class="md-raised md-dense" @click="showAddTelDirPrepaid">{{ $t('Direction') }}</md-button>
              <md-button class="md-raised md-dense" @click="showAddTelZonesPrepaid">{{ $t('Zone') }}</md-button>
              <b-card>
                <b-table striped small hover responsive :fields="prepaidValuesFields" :items="prepaidRoll" show-empty :emptyText="$t('There are no records to show')">
                  <template #cell()="data">
                    <span v-if="['nameTel'].includes(data.field.key)">
                      <i @click.stop="deletePrepaid(data.item)" class="danger fa fa-trash-alt fa-lg" />
                      <b>{{ data.value }}</b>
                    </span>
                    <md-field v-if="['cost_info'].includes(data.field.key)" class="small">
                      <md-input v-model="data.item[data.field.key].prepaid" type="number"></md-input>
                    </md-field>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Fixed cost')">
              <md-button class="md-raised md-dense" @click="showAddTelDirFixed">{{ $t('Direction') }}</md-button>
              <md-button class="md-raised md-dense" @click="showAddTelZonesFixed">{{ $t('Zone') }}</md-button>
              <b-card>
                <b-table striped small hover responsive :fields="prepaidValuesFields" :items="fixedRoll" show-empty :emptyText="$t('There are no records to show')">
                  <template #cell()="data">
                    <span v-if="['nameTel'].includes(data.field.key)">
                      <i @click.stop="deleteFixed(data.item)" class="danger fa fa-trash-alt fa-lg" />
                      <b>{{ data.value }}</b>
                    </span>
                    <md-field v-if="['cost_info'].includes(data.field.key)" class="small">
                      <md-input v-model="data.item[data.field.key].fixed_cost" type="number"></md-input>
                    </md-field>
                  </template>
                </b-table>
              </b-card>
            </b-tab>
            <b-tab :title="$t('Radius parameters')">
              <b-row>
                <b-col style="margin:5px">
                  <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
                </b-col>
              </b-row>
              <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
                <template v-slot:cell(actions)="row">
                  <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg" />
                  <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg" />
                </template>
              </b-table>
            </b-tab>
          </b-tabs>

        <modal-ok-cancel @save="saveTelephonyService" @cancel="$refs.modalTelephoneService.hide" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange" size="lg">
      <b-table striped hover
      :items="timeRangeList"
      :fields="timeRangeFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTimeRange">
      </b-table>

      <modal-ok-cancel @save="addTimeRange" @cancel="hideAddTimeRange" size="lg"/>
    </b-modal>

    <b-modal @show="clearModalTelDirs" hide-footer :title="$t('Telephone directions')" ref="modalTelDirections" size="xl">
      <table-manager-search @filterChanged="filterChangedDIRECTIONS" :options="optionsDirections"/>

      <b-table striped hover small
      :items="telDirectionsItems"
      :fields="telDirectionsFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTelDirections">
      </b-table>

        <table-manager-bottom
          :totalRows="telDirectionsTotal" :perPage="perPage"
          v-model="currentPage"/>

      <modal-ok-cancel @save="addTelDirections" @cancel="hideAddTelDirections" size="lg"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Telephone zones')" ref="modalTelZones" size="lg">
      <b-table striped hover
      :items="telZonesItems"
      :fields="telZonesFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTelZones">
      </b-table>

      <modal-ok-cancel @save="addTelZones" @cancel="hideAddTelZones" size="lg"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<style>
div.md-field.small {
  margin:0px 0px 4px 0px;
  padding-top:0px;
  min-height:0px
}

div.col.bordered {
  min-height: 38px;
  border-width: 1px;
  border-style: solid;
  border-color:rgba(0, 0, 0, 0.125);
}
</style>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    serviceType: null,
    schemeList: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      optionsDirections: {
        isShowAddButton: false
      },
      showAllDirs: true,
      showAllZones: true,
      isBorder: false,
      isFixed: false,
      isPrepaid: false,
      borderRoll: [],
      prepaidRoll: [],
      fixedRoll: [],
      requestTelDir: {
        'offset': 0,
        'count': 100,
        'excepted_dir_ids': []
      },
      rowTimeRange: null,
      rowTelDirections: null,
      rowTelZones: null,
      timeRangeList: [],
      timeRangeFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Range'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true}
      ],
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID'},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'create_date', label: this.$i18n.t('Created on'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'zones', label: this.$i18n.t('Zone')},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix')},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix')}
      ],
      telZonesFields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true, formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true}
      ],
      costTimeRange: [],
      costTable: [],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      selectChargeMethod: 1,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      tarifficationBordersFields: [
        {key: 'nameTel', label: this.$t('Direction/zone'), sortable: true},
        {key: 'border', label: this.$i18n.t('Border'), sortable: true},
        {key: 'cost_coefficient', label: this.$i18n.t('Coefficient'), sortable: true}
      ],
      prepaidValuesFields: [
        {key: 'nameTel', label: this.$t('Direction/zone'), sortable: true},
        {key: 'cost_info', label: this.$i18n.t('Value'), sortable: true}
      ],
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      radItemForEdit: null
    }
  },
  methods: {
    saveTelephonyService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.costTable.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Price editor table is empty'), 'Error')
        return
      }

      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = 'multiple_linking' in this.editItem.service_data ? this.editItem.service_data.multiple_linking : 0
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.telephony_service_data.cost_info.min_charge = Number(this.editItem.telephony_service_data.cost_info.min_charge)
      this.editItem.telephony_service_data.cost_info.free_time = Number(this.editItem.telephony_service_data.cost_info.free_time)
      this.editItem.telephony_service_data.cost_info.first_period_length = Number(this.editItem.telephony_service_data.cost_info.first_period_length)
      this.editItem.telephony_service_data.cost_info.first_period_step = Number(this.editItem.telephony_service_data.cost_info.first_period_step)
      this.editItem.telephony_service_data.cost_info.second_period_step = Number(this.editItem.telephony_service_data.cost_info.second_period_step)
      this.editItem.telephony_service_data.cost_info.time_unit_size = Number(this.editItem.telephony_service_data.cost_info.time_unit_size)
      this.editItem.periodic_service_data.radius_sessions_limit = Number(this.editItem.periodic_service_data.radius_sessions_limit)
      this.editItem.telephony_service_data.cost_info.cost_table = []
      let tmpNewCosts = JSON.parse(JSON.stringify(this.itemsFromCostTable))

      for (let elNewCosts of tmpNewCosts) {
        for (let elOldCosts of this.costTable) {
          if (elNewCosts.tariff_key === elOldCosts.tariff_key) {
            elOldCosts.cost_info = []
            for (let elNewTimeRanges in elNewCosts) {
              if (['label', 'tariff_key'].includes(elNewTimeRanges)) {
                continue
              }
              let newCost = {
                time_range_id: Number(elNewTimeRanges),
                cost: Number(elNewCosts[elNewTimeRanges])
              }
              elOldCosts.cost_info.push(newCost)
            }
          }
        }
      }

      for (let el of this.costTable) {
        if (!el.cost_info.length) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Costs info is empty'), 'Error')
          return
        }

        let newCost = {
          'tariff_key': 0,
          'cost_info': {
            'borders': [],
            'costs': [],
            'fixed_cost': 0,
            'prepaid': 0
          }
        }
        newCost.tariff_key = el.tariff_key
        newCost.cost_info.costs = el.cost_info
        this.editItem.telephony_service_data.cost_info.cost_table.push(JSON.parse(JSON.stringify(newCost)))
      }
      for (let curCost of this.editItem.telephony_service_data.cost_info.cost_table) {
        for (let curFixed of this.fixedRoll) {
          if (curFixed.tariff_key === curCost.tariff_key) {
            curCost.cost_info.fixed_cost = Number(curFixed.cost_info.fixed_cost)
          }
        }
      }
      for (let curCost of this.editItem.telephony_service_data.cost_info.cost_table) {
        for (let curPrepaid of this.prepaidRoll) {
          if (curPrepaid.tariff_key === curCost.tariff_key) {
            curCost.cost_info.prepaid = Number(curPrepaid.cost_info.prepaid)
          }
        }
      }

      for (let curCost of this.editItem.telephony_service_data.cost_info.cost_table) {
        for (let curBorder of this.borderRoll) {
          if (curBorder.tariff_key === curCost.tariff_key) {
            let newBorder = {
              'border': 0,
              'cost_coefficient': 0
            }
            newBorder.border = Number(curBorder.border)
            newBorder.cost_coefficient = Number(curBorder.cost_coefficient)
            curCost.cost_info.borders.push(newBorder)
          }
        }
      }
      for (let curTable of this.editItem.telephony_service_data.cost_info.cost_table) {
        for (let curCost of curTable.cost_info.costs) {
          curCost.cost = Number(curCost.cost)
        }
      }
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_TELEPHONY_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_TELEPHONY_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t(response.data.error), 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalTelephoneService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id

          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.periodic_service_data.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }

          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', {set_object_id: sid, set_type: 6, attrs: this.radiusAttrItems})
        }
      })
    },
    shown () {
      this.costTable = []
      this.fixedRoll = []
      this.prepaidRoll = []
      this.borderRoll = []
      this.costTimeRange = []
      this.timeRangeList = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TIME_RANGE']))
      for (let el of this.timeRangeList) {
        el.range = ''
        for (let elRange of el.slices) {
          el.range += elRange.start_wday +
          ' - ' + elRange.end_wday + ' ' + elRange.start_hour +
          ':' + elRange.start_min + ':' + elRange.start_sec +
          ' - ' + elRange.end_hour + ':' + elRange.end_min +
          ':' + elRange.end_sec + '; '
        }
      }
      if (this.isEdit || this.isTariffPlan) {
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SERVICES']))
        for (let el of this.radiusAttrItems) {
          el.value = el.attr_value
          if (el.tag && (el.vendor === 0)) {
            el.value = ':' + el.tag + ':' + el.attr_value
          }
          switch (el.attr_type) {
            case 1:
              el.attrType = this.$i18n.t('Number')
              break
            case 2:
              el.attrType = this.$i18n.t('String')
              break
            case 3:
              el.attrType = 'IP'
              break
            case 4:
              el.attrType = this.$i18n.t('Binary')
              break
          }
        }
      } else {
        this.radiusAttrItems = []
      }
      if (this.isEdit || this.isTariffPlan) {
        this.costTable = JSON.parse(JSON.stringify(this.editItem.telephony_service_data.cost_info.cost_table))
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key >= 1000000) {
            for (let j in this.telDirectionsItems) {
              if (this.costTable[i].tariff_key === this.telDirectionsItems[j].dir_id) {
                this.costTable[i].nameTel = this.telDirectionsItems[j].name
              }
            }
          } else {
            for (let j in this.telZonesItems) {
              if (this.costTable[i].tariff_key === this.telZonesItems[j].zone_id) {
                this.costTable[i].nameTel = this.telZonesItems[j].name
              }
            }
          }
        }

        this.costTimeRange = JSON.parse(JSON.stringify(this.costTable[0].cost_info.costs))
        for (let i in this.costTimeRange) {
          for (let j in this.timeRangeList) {
            if (this.costTimeRange[i].time_range_id === this.timeRangeList[j].tr_id) {
              this.costTimeRange[i].nameTimeRange = this.timeRangeList[j].name
            }
          }
        }
        let arr = JSON.parse(JSON.stringify(this.costTable))
        this.prepaidRoll = []
        this.fixedRoll = []
        for (let i in arr) {
          if (arr[i].cost_info.fixed_cost) {
            this.fixedRoll.push(arr[i])
          }
          if (arr[i].cost_info.prepaid) {
            this.prepaidRoll.push(arr[i])
          }
        }
        this.borderRoll = []
        for (let i in arr) {
          for (let j in arr[i].cost_info.borders) {
            arr[i].cost_info.borders[j].nameTel = JSON.parse(JSON.stringify(arr[i].nameTel))
            arr[i].cost_info.borders[j].tariff_key = JSON.parse(JSON.stringify(arr[i].tariff_key))
            this.borderRoll.push(arr[i].cost_info.borders[j])
          }
        }
        for (let i in this.costTable) {
          this.costTable[i].cost_info = this.costTable[i].cost_info.costs
        }
      }
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== row.item
      })
    },
    showAddTimeRange () {
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    hideAddTimeRange () {
      this.$refs.modalTimeRange.hide()
    },
    rowClickTimeRange (row) {
      this.rowTimeRange = row
    },
    addTimeRange () {
      if (!this.rowTimeRange) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select time range'), 'Error')
        return
      }
      for (let i in this.costTimeRange) {
        if (this.costTimeRange[i].time_range_id === this.rowTimeRange.tr_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
          return
        }
      }
      this.rowTimeRange.cost = 0
      this.rowTimeRange.nameTimeRange = this.rowTimeRange.name
      this.rowTimeRange.time_range_id = this.rowTimeRange.tr_id
      this.costTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      for (let curCostTable of this.costTable) {
        curCostTable.cost_info.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
      }

      this.hideAddTimeRange()
    },
    clearModalTelDirs () {
      this.filter = ''
      this.currentPage = 1
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
    },
    showAddTelDirections () {
      this.rowTelDirections = null
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = false
      this.showAllDirs = true
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirBorder () {
      this.isBorder = true
      this.isFixed = false
      this.isPrepaid = false
      this.showAllDirs = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirPrepaid () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = true
      this.showAllDirs = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    showAddTelDirFixed () {
      this.isBorder = false
      this.isFixed = true
      this.isPrepaid = false
      this.showAllDirs = false
      this.rowTelDirections = null
      this.$refs.modalTelDirections.show()
    },
    hideAddTelDirections () {
      this.$refs.modalTelDirections.hide()
    },
    rowClickTelDirections (row) {
      this.rowTelDirections = row
    },
    addTelDirections () {
      if (!this.rowTelDirections) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      if (this.isBorder || this.isPrepaid || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelDirections.dir_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'nameTel': '',
              'tariff_key': 0,
              'border': 0,
              'cost_coefficient': 1
            }
            newBorder.nameTel = this.rowTelDirections.name
            newBorder.tariff_key = this.rowTelDirections.dir_id
            this.borderRoll.push(newBorder)
          }
          if (this.isPrepaid) {
            for (let i in this.prepaidRoll) {
              if (this.prepaidRoll[i].tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newPrepaid = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'prepaid': 0
              }
            }
            newPrepaid.nameTel = this.rowTelDirections.name
            newPrepaid.tariff_key = this.rowTelDirections.dir_id
            this.prepaidRoll.push(newPrepaid)
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelDirections.dir_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelDirections.name
            newFixed.tariff_key = this.rowTelDirections.dir_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelDirections.dir_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': []
        }
        newCostTable.nameTel = this.rowTelDirections.name
        newCostTable.tariff_key = this.rowTelDirections.dir_id
        newCostTable.cost_info = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.hideAddTelDirections()
    },
    showAddTelZones () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = false
      this.showAllZones = true
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesBorder () {
      this.isBorder = true
      this.isFixed = false
      this.isPrepaid = false
      this.showAllZones = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesPrepaid () {
      this.isBorder = false
      this.isFixed = false
      this.isPrepaid = true
      this.showAllZones = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    showAddTelZonesFixed () {
      this.isBorder = false
      this.isFixed = true
      this.isPrepaid = false
      this.showAllZones = false
      this.rowTelZones = null
      this.$refs.modalTelZones.show()
    },
    hideAddTelZones () {
      this.$refs.modalTelZones.hide()
    },
    rowClickTelZones (row) {
      this.rowTelZones = row
    },
    addTelZones () {
      if (!this.rowTelZones) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone zone'), 'Error')
        return
      }
      if (this.isBorder || this.isPrepaid || this.isFixed) {
        let isBoolean = this.costTable.find(el => {
          return el.tariff_key === this.rowTelZones.zone_id
        })
        if (isBoolean) {
          if (this.isBorder) {
            let newBorder = {
              'nameTel': '',
              'tariff_key': 0,
              'border': 0,
              'cost_coefficient': 1
            }
            newBorder.nameTel = this.rowTelZones.name
            newBorder.tariff_key = this.rowTelZones.zone_id
            this.borderRoll.push(newBorder)
          }
          if (this.isPrepaid) {
            for (let i in this.prepaidRoll) {
              if (this.prepaidRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newPrepaid = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'prepaid': 0
              }
            }
            newPrepaid.nameTel = this.rowTelZones.name
            newPrepaid.tariff_key = this.rowTelZones.zone_id
            this.prepaidRoll.push(newPrepaid)
          }
          if (this.isFixed) {
            for (let i in this.fixedRoll) {
              if (this.fixedRoll[i].tariff_key === this.rowTelZones.zone_id) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
                return
              }
            }
            let newFixed = {
              'nameTel': '',
              'tariff_key': 0,
              'cost_info': {
                'fixed_cost': 0
              }
            }
            newFixed.nameTel = this.rowTelZones.name
            newFixed.tariff_key = this.rowTelZones.zone_id
            this.fixedRoll.push(newFixed)
          }
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Not in the table price'), 'Error')
          return
        }
      } else {
        for (let i in this.costTable) {
          if (this.costTable[i].tariff_key === this.rowTelZones.zone_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
            return
          }
        }
        let newCostTable = {
          'tariff_key': 0,
          'nameTel': '',
          'cost_info': []
        }
        newCostTable.nameTel = this.rowTelZones.name
        newCostTable.tariff_key = this.rowTelZones.zone_id
        newCostTable.cost_info = JSON.parse(JSON.stringify(this.costTimeRange))
        this.costTable.push(newCostTable)
      }
      this.hideAddTelZones()
    },
    deleteTimeRange (item) {
      this.costTimeRange = this.costTimeRange.filter((value) => {
        return value.time_range_id !== item.time_range_id
      })
      for (let curTable of this.costTable) {
        curTable.cost_info = curTable.cost_info.filter((value) => {
          return value.time_range_id !== item.time_range_id
        })
      }
    },
    deleteCost (item) {
      this.costTable = this.costTable.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteBorder (item) {
      this.borderRoll = this.borderRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deletePrepaid (item) {
      this.prepaidRoll = this.prepaidRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    deleteFixed (item) {
      this.fixedRoll = this.fixedRoll.filter((value) => {
        return value.tariff_key !== item.tariff_key
      })
    },
    filterChangedDIRECTIONS (value) {
      this.filter = value
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (this.currentPage - 1) * this.perPage, 'filter': value})
      } else {
        this.currentPage = 1
      }
    }
  },
  computed: {
    telDirectionsTotal () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].total))
    },
    fieldsFromCostTimeRange () {
      let tmp = [{
        key: 'label',
        label: this.$t('Direction/zone')
      }]
      for (let el of this.costTimeRange) {
        let newEl = {
          key: String(el.time_range_id),
          label: el.nameTimeRange
        }
        tmp.push(newEl)
      }
      return tmp
    },
    itemsFromCostTable () {
      let tmp = []
      for (let el of this.costTable) {
        let newEl = {
          label: el.nameTel,
          tariff_key: el.tariff_key
        }
        for (let elCI of el.cost_info) {
          this.$set(newEl, elCI.time_range_id, elCI.cost)
        }
        tmp.push(newEl)
      }
      return tmp
    },
    telDirectionsItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'])).items
      for (let el of copy) {
        for (let elZone of this.$store.getters['Tariffing/TEL_ZONES']) {
          if (el.zone_id === elZone.zone_id) {
            el.zones = elZone.name + ' (' + elZone.zone_id + ')'
            break
          }
        }
      }
      if (!this.showAllDirs) {
        let dirsInsidePrices = []
        for (let elAllDirs of copy) {
          let isFound = this.costTable.find(el => {
            return el.tariff_key === elAllDirs.dir_id
          })
          if (isFound) {
            dirsInsidePrices.push(elAllDirs)
          }
        }
        return dirsInsidePrices
      }

      return copy
    },
    telZonesItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))
      if (!this.showAllZones) {
        let zonesInsidePrices = []
        for (let elAllZones of copy) {
          let isBoolean = this.costTable.find(el => {
            return el.tariff_key === elAllZones.zone_id
          })
          if (isBoolean) {
            zonesInsidePrices.push(elAllZones)
          }
        }
        return zonesInsidePrices
      }
      return copy
    }
  },
  watch: {
    currentPage (val) {
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (val - 1) * this.perPage, 'filter': this.filter})
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formTelephonyService.vue